<template>
  <div>
    <div class="popup-wrapper" @click.self="close">

      <div class="popup-container xl">
        <div class="button close">
          <span role="button" class="btn" @click="close">
            <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
          </span>
        </div>
        <div class="popup mb40">
          <div class="popup-title">
            <span class="hdg02">プロフィール</span>
            <span class="text-logout" role="button" @click="openLogout">ログアウトする</span>
          </div>
          <div class="popup-content">
            <div class="profile">
              <div class="profile-menu">
                <ul class="profile-menu-list">
                  <li class="profile-menu-item">
                    <table>
                      <colgroup>
                        <col style="width:25%">
                        <col style="width:75%">
                      </colgroup>
                      <tbody>
                        <tr>
                          <th>アカウント名</th>
                          <td><span class="data">{{ group1.name }}</span></td>
                        </tr>
                        <tr>
                          <th>メールアドレス</th>
                          <td><span class="data">{{ group1.email }}</span></td>
                        </tr>
                        <tr>
                          <th>権限</th>
                          <td><span class="data">{{ group1.authDisp }}</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </li>
                  <li class="profile-menu-item">
                    <table>
                      <colgroup>
                        <col style="width:25%">
                        <col style="width:75%">
                      </colgroup>
                      <tbody>
                        <tr>
                          <th>付与ライセンス</th>
                          <td>
                            <p class="txt-sup">ライセンス管理については、お客様の管理者にお問い合わせください。</p>
                            <div class="column scroll-area"
                              style="max-height:120px;"
                              >
                              <template v-for="(name, index) in group1.product_name_lists">
                                <div class="column-item col-12" :key="'product_name_' + index">
                                  <span class="data">{{ name }}</span>
                                </div>
                              </template>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </li>
                  <li class="profile-menu-item"
                    v-if="!isFromAdminSystem()">
                    <table>
                      <colgroup>
                        <col style="width:25%">
                        <col style="width:75%">
                      </colgroup>
                      <tbody>
                        <tr>
                          <th>アップデート通知</th>
                          <td>
                            <p class="hdg05 mb12">アップデート通知の配信方法</p>
                            <p class="txt-sup">アップデート通知とは、購読中の書籍の更新情報、最新ナレッジで気になるキーワードがあった場合に、通知とメールでお知らせする機能です。</p>
                            <div class="mb20">
                              <div v-for="(item, index) in group1.alert_flg_list" :key="'alert_flg_' + index" class="formparts radio inline">
                                <input type="radio" :value="item.value" :id="'alert_flg_' + item.value" v-model.number="group1.alert_flg" @change="group1.onAlertFlgChanged">
                                <label :for="'alert_flg_' + item.value" role="button">{{ item.name }}</label>
                              </div>
                            </div>

                            <template v-if="group1.alert_flg !== 9">
                              <hr class="mb20">
                              <p class="hdg05 mb12">書籍の更新情報</p>
                              <p class="txt-sup">更新情報をご希望されるパッケージ、書籍を選択してください。選択されていない場合は、配信されません。</p>
                              <div class="column mb20">
                                <div class="column-item col-8">
                                  <div class="formparts text is-inactive">
                                    <input type="text" readonly :value="group1.alert_booksDisp" placeholder="選択されていません">
                                  </div>
                                </div>
                                <div class="column-item col-4 space-left">
                                  <div class="button"
                                    @click="state.visibleProfileContractedBookSetting = true"
                                  >
                                    <button class="btn" type="button" name="button">書籍の設定</button>
                                  </div>
                                </div>
                              </div>
                            </template>

                            <template v-if="group1.alert_flg !== 9 && group1.isKnowledgeContentsShown">
                              <hr class="mb20">
                              <p class="hdg05 mb12">気になるキーワード</p>
                              <p class="txt-sup">気になるキーワードに合致した最新ナレッジをアップデート通知として配信します。キーワードは2文字以上、最大10点まで設定可能です。設定されていない場合は、配信されません。</p>

                              <form @submit.prevent="group1.onAddAlertTagButtonClicked(group1.alert_tag)">
                                <div v-if="group1.alert_tags.length < 10" class="formparts function">
                                  <input type="text" v-model="group1.alert_tag" placeholder="キーワードを入力">
                                  <div @click="group1.onAddAlertTagButtonClicked(group1.alert_tag)" class="button" role="button"><FontawesomeIcon icon="plus" class="icn" /></div>
                                </div>
                                <div v-else class="formparts text">
                                  <input type="text" v-model="group1.alert_tag" placeholder="キーワードを入力">
                                </div> 
                                <p v-if="group1.error_alert_tags !== ''" class="error-message">{{ group1.error_alert_tags }}</p>
                              </form>

                              <div class="mt8">

                                <div v-for="(tag, index) in group1.alert_tags" :key="'alert_tags_' + index" class="tag">
                                  <div role="button" class="tag-wrap">
                                    <span class="tag-text">{{ tag }}</span>
                                    <span @click="group1.onDeleteAlertTagButtonClicked(tag)" class="tag-close"><FontawesomeIcon icon="times" size="xs" class="icn" /></span>
                                  </div>
                                </div>

                              </div>

                            </template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </li>
                </ul>
              </div>
              <div class="profile-config">
                <template v-if="!isFromAdminSystem()">
                  <div class="profile-config-image" role="button" @click="openProfileChangeImage">
                    <span v-if="group1.user_icon_image" class="profile-config-image-img" 
                      :style="{'backgroundImage':'url(' + group1.user_icon_image +')'}"></span>
                    <span v-else class="profile-config-image-no-image">{{ group1.name.slice(0, 1) }}</span>
                    <span class="profile-config-image-txt">プロフィール画像を変更する</span>
                  </div>
                  <div class="profile-config-bg" role="button" @click="openProfileChangeBackground">
                    <span class="profile-config-bg-img" :style="{'backgroundImage':'url(' + group1.backgroundImage + ')'}"></span>
                    <span class="profile-config-bg-txt">背景画像を変更する</span>
                  </div>
                  <div class="profile-config-password" role="button" @click="openPasswordReminder">
                    <span class="profile-config-password-img">
                      <FontawesomeIcon :icon="['fal','lock-alt']" size="lg" class="icn" />
                    </span>
                    <span class="profile-config-password-txt">パスワードを変更する</span>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ポップアップ上にさらにポップアップを表示する場合<div class="popup-wrapper"> の後ろに書く必要がある。
      そうしないと、ダークレイヤーが画面高さで固定になり、スクロールするとダークレイヤーがかかっていない状態になる。 -->

    <!-- ログアウト -->
    <transition name="popup">
      <PCLogoutConfirm
        v-if="state.visibleLogout"
        @closeLogout="state.visibleLogout = false"
      />
    </transition>

    <!-- 書籍の設定ウィンドウ -->
    <transition name="popup">
      <PCProfileContractedBookSetting
        v-show="state.visibleProfileContractedBookSetting"
        :startLoading="state.visibleProfileContractedBookSetting"
        :currentAlertBooks="group1.alert_books"
        @emitSetAlertBooks="group1.setAlertBooks"
        @closeProfileContractedBookSetting="state.visibleProfileContractedBookSetting = false"
      />
    </transition>

    <!-- パスワード変更1 -->
    <!-- <transition name="popup">
      <PCPasswordChangeConfirm
        v-if="state.visiblePasswordChangeConfirm"
        @closePasswordChangeConfirm="state.visiblePasswordChangeConfirm = false"
        @openPasswordChangeComplete="state.visiblePasswordChangeComplete = true"
      />
    </transition> -->

    <!-- パスワード変更2 -->
    <!-- <transition name="popup">
      <PCPasswordChangeComplete
        v-if="state.visiblePasswordChangeComplete"
        @closePasswordChangeComplete="state.visiblePasswordChangeComplete = false"
      />
    </transition> -->

    <!-- プロフィール画像変更 -->
    <transition name="popup">
      <PCProfileChangeImage
        v-if="state.visibleProfileImage"
        @closeProfileChangeImage="state.visibleProfileImage = false"
      />
    </transition>

    <!-- 背景画像変更 -->
    <transition name="popup">
      <PCProfileChangeBackground
        v-if="state.visibleProfileBg"
        @closeProfileChangeBackground="state.visibleProfileBg = false"
      />
    </transition>

  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onBeforeMount } from '@vue/composition-api'
import * as common from '@/util/common'
import PCLogoutConfirm from '@/components/pc/popup/PCLogoutConfirm'
import PCProfileContractedBookSetting from '@/components/pc/popup/PCProfileContractedBookSetting'
// import PCPasswordChangeConfirm from '@/components/pc/popup/PCPasswordChangeConfirm'
// import PCPasswordChangeComplete from '@/components/pc/popup/PCPasswordChangeComplete'
import PCProfileChangeImage from '@/components/pc/popup/PCProfileChangeImage'
import PCProfileChangeBackground from '@/components/pc/popup/PCProfileChangeBackground'

import * as logicProfile from '@/logic/profile/Profile'
import { isFromAdminSystem } from '@/util/common'

export default defineComponent({
  name: 'PCProfile',
  components: {
    PCLogoutConfirm,
    PCProfileContractedBookSetting,
    // PCPasswordChangeConfirm,
    // PCPasswordChangeComplete,
    PCProfileChangeImage,
    PCProfileChangeBackground
  },
  setup (props, context) {

    onBeforeMount(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicProfile.getGroup(props, context)

    const state = reactive({
      visibleLogout: false,
      visibleProfileContractedBookSetting: false,
      visibleProfileImage: false,
      visibleProfileBg: false,
      visiblePasswordChangeConfirm: false,
      visiblePasswordChangeComplete: false
    })

    const close = () => {
      context.emit('closeProfile')
    }
    const openLogout = () => {
      // context.emit('openLogout')
      // @openLogout="state.visibleLogout = true"
      state.visibleLogout = true
    }
    // const openPasswordChangeConfirm = () => {
    //   // context.emit('openPasswordChangeConfirm')
    //   // @openPasswordChangeConfirm="state.visiblePasswordChangeConfirm = true"
    //   state.visiblePasswordChangeConfirm = true
    // }
    const openPasswordReminder = () => {
      // パスワードリマインダを別ウィンドウで表示
      window.open('/lc/app/public/password-reminder/index', 'password-reminder')
    }
    const openProfileChangeImage = () => {
      // context.emit('openProfileChangeImage')
      // @openProfileChangeImage="state.visibleProfileImage = true"
      state.visibleProfileImage = true
    }
    const openProfileChangeBackground = () => {
      // context.emit('openProfileChangeBackground')
      // @openProfileChangeBackground="state.visibleProfileBg = true"
      state.visibleProfileBg = true
    }
    const openProfileChangePasssword = () => {
      context.emit('openProfileChangePasssword')
    }
    const config = reactive({
      profileImage: 'http://satyr.io/200x300'
    })

    return {
      group1,
      isFromAdminSystem,
      state,
      close,
      openLogout,
      // openPasswordChangeConfirm,
      openPasswordReminder,
      openProfileChangeImage,
      openProfileChangeBackground,
      openProfileChangePasssword,
      config
    }
  }
})
</script>

<style lang="scss" scoped>
  .popup-wrapper {
    z-index: $index-menu-account;
  }
  .popup-content {
    position: relative;
    padding-top: 0!important;
    padding-bottom: 0!important;
  }
  .popup-title {
    position: relative;
    display: flex;
    align-items: center;
    .text-logout {
      display: inline-block;
      margin-left: 40px;
      color: $color-link;
      font-size: 1.6rem;
    }
  }
  hr {
    border: 0;
    border-top: 1px dotted $color-content-nega;
  }
  .profile {
    display: flex;
    &-menu {
      width: 70%;
      padding-right: 40px;
      padding-bottom: 20px;
      &-list {
        list-style: none;
      }
      &-item {
        padding: 20px 0;
        & + li {
          border-top: 1px solid $color-line;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          th,td {
            font-size: 1.6rem;
            vertical-align: baseline;
          }
          th {
            color: #3E3E3E;
            padding: 8px 16px 8px 0;
            white-space: nowrap;
          }
          td {
            color: #555555;
            .data {
              padding: 8px 0;
              display: inline-block;
            }
            .scroll-area {
              overflow-y: auto;
            }
          }
        }
      }
    }
    &-config {
      width: 30%;
      margin-top: -20px;
      margin-bottom: 20px;
      background-color: $color-bg-paper;
      border: 1px solid $color-line;
      border-radius: 8px;
      &-image,
      &-bg,
      &-password {
        padding: 40px;
        &-img {
          display: block;
          width: 60%;
          margin: 0 auto;
          background-position: center;
          background-size: cover;
        }
        &-txt {
          display: block;
          text-align: center;
          width: 100%;
          color: $color-link;
          margin-top: 20px;
          font-size: 1.6rem;
        }
        @include hoverOpacity();
      }
      &-image {
        &-img {
          padding-top: 60%;
          border-radius: 50%;
        }
        &-no-image {
          width: 128px;
          height: 128px;
          margin: 0 auto;
          border-radius: 50%;
          overflow: hidden;
          background-size: cover;
          background-position: center;
          background-color: $color-no-image;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 6.4rem;
          font-weight: bold;
          color: $color-hdg;
        }
      }
      &-bg {
        border-top: 1px solid $color-line;
        &-img {
          padding-top: 40%;
          border-radius: 8px;
        }
      }
      &-password {
        border-top: 1px solid $color-line;
        &-img {
          border-radius: 50%;
          background-color: #fff;
          width: 128px;
          height: 128px;
          display: flex;
          justify-content: center;
          align-items: center;
          .icn {
            font-size: 4.8rem;
            color: $color-content;
          } 
        }
      }
    }
  }
</style>
